import { render, staticRenderFns } from "./FontOptions.vue?vue&type=template&id=475dfd84"
import script from "./FontOptions.vue?vue&type=script&lang=js"
export * from "./FontOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports